import { render, staticRenderFns } from "./vip-alert.vue?vue&type=template&id=25e18b7e&scoped=true&"
import script from "./vip-alert.vue?vue&type=script&lang=js&"
export * from "./vip-alert.vue?vue&type=script&lang=js&"
import style0 from "./vip-alert.vue?vue&type=style&index=0&id=25e18b7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e18b7e",
  null
  
)

export default component.exports